import React from "react";
import { isMatch } from "lodash";
import { Navigation } from "./Navigation";

export abstract class Location<Params extends {}> {
  constructor(public readonly params: Params) {}

  navigation: Navigation;
  abstract render(): React.ReactElement<any>;
  abstract toURI(): string;

  get className() {
    return this.constructor.name;
  }

  equals(location: Location<Params>) {
    return isMatch(this.params, location.params) && this.className === location.className;
  }
}

export type AnyLocation = Location<any>;
